goog.provide('el8.ptdata.ptProviders');

goog.require('el8.model.base');
goog.require('el8.data.physicians');
goog.require('el8.service.urls');
goog.require('el8.service.tz');
goog.require('el8.template.ptdata.ptProviders');


el8.ptdata.ptProviders = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.prototype.populate = function(spec) {
        spec = spec || {};
        if (spec.physician) {
            spec.physician_id = el8.data.physicians.create(spec.physician).getId();
        }
        this.parent.populate.call(this, spec);
    };

    _class.addStringProperty('group');
    _class.addIntProperty('rank');
    _class.addStringProperty('treatmentReason');
    _class.addIntProperty('physicianId');

    _class.addProperty('specialtyCategories');

    _class.addIntProperty('publicAccessUserId');
    _class.addStringProperty('providerLogo'); // 'emr', 'passport', or ''

    _class.addStringProperty('practicingStatus');

    _class.addDateTime('lastActivityDate');
    _class.addProperty('activityDetails');
    _class.addProperty('enterprise'); // this matches CareTeamProvider to allow frontend to show enterprise information

    var _CARE_EVENTS = ['referral', 'letter', 'medorder', 'immunization', 'consultation_report', 'order'];

    _class.prototype.getPhysician = function() {
        return this.getPhysicianId() ? el8.data.physicians.getById(this.getPhysicianId()) : null;
    };
    _class.prototype.setSortSequence = function(zeroIndexedSequence, length) {
        // Because this list is reverse-ordered by "rank" and indexed at 1, we add
        // this helper method so we don't go nuts
        this.setRank(length - zeroIndexedSequence);
    };
    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        var physician = this.getPhysician();
        if (physician) {
            mapped['physician'] = physician.asSoyMap();
        }
        mapped['lastMedFillDate'] = el8.service.tz.soyStr(this.getLastMedFillDate());
        mapped['lastCareEventDate'] = el8.service.tz.soyStr(this.getLastCareEventDate());
        mapped['careEventDetails'] = this.getSoyCareEventDetails();
        delete mapped['activityDetails'];
        return mapped;
    };
    _class.prototype.getLastMedFillDate = function() {
        if (this.getActivityDetails() && this.getActivityDetails()['rx']) {
            return el8.service.tz.toTzDateTime(this.getActivityDetails()['rx']['last_activity']);
        }
    };
    _class.prototype.getLastCareEventDate = function() {

        var details = this.getActivityDetails();
        if (!details) { return null; }

        var dates = [];
        _.each(_CARE_EVENTS, function(evt, index) {
            if (details[evt] && details[evt]['last_activity']) {
                dates.push(el8.service.tz.toTzDateTime(details[evt]['last_activity']));
            }
        });

        return _.max(dates, function(d) { return d.getTime(); });
    };
    _class.prototype.getSoyCareEventDetails = function() {
        var results = [];
        var details = this.getActivityDetails();
        if (details) {
            _.each(_CARE_EVENTS, function(evt, index) {
                if (details[evt] && (details[evt]['count'] > 0)) {
                    results.push({
                        count: details[evt]['count'],
                        earliestActivity: details[evt]['earliest_activity'],
                        latestActivity: (details[evt]['count'] === 1) ? null : details[evt]['last_activity'],
                        careEvent: evt
                    });
                }
            });
        }
        return results;
    };
    _class.prototype.saveTreatmentReason = function(val) {
        this.setTreatmentReason(val);
        var that = this;
        $.el8_ajax({
            type: 'POST',
            data: JSON.stringify({treatment_reason: val}),
            url: el8.service.urls.get('patientProvider', [that.getId()]),
            success: function(data) {
                that.populate(data);
                el8.ptdata.ptProviders.trigger(EVENTS.UPDATED, that);
            }
        });
    };
    _class.prototype.updatePhysicianId = function(physicianId) {
        if (!physicianId) { return; }
        this.setPhysicianId(physicianId);
        var that = this;
        $.el8_ajax({
            type: 'POST',
            data: JSON.stringify({physician_id: physicianId}),
            url: el8.service.urls.get('patientProvider', [that.getId()]),
            success: function(data) {
                that.populate(data);
                el8.ptdata.ptProviders.trigger(EVENTS.UPDATED, that);
            }
        });
    };
    _class.prototype.getNoteSummary = function() {
        return el8.template.ptdata.ptProviders.noteSummary(this.asSoyMap()).el8_unescape();
    };

    /**
     * Define EntitySet
     */
    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('allPatientProviders'); },
        // For this model, server reverse orders by rank (i.e. rank 1 is at bottom)
        sortFn: function(a, b) { return b.getRank() - a.getRank(); },
        deleteFn: function(item, successCallbackFn) {
            el8.appservice.notifier.notify('Removing provider from list...');
            $.el8_ajax({
                url: el8.service.urls.get('patientProvider', [item.getId()]),
                type: 'DELETE',
                success: function(data) {
                    el8.appservice.notifier.notify('Provider removed from list.');
                    if (successCallbackFn) { successCallbackFn(item); }
                }
            });
        }
    });

    that.getPhysicianIdMap = function() {
        var m = {};
        _.each(that.all(), function(a) {
            m[a.getPhysicianId()] = true;
        });
        return m;
    };
    that.getPhysicianNpiMap = function() {
        var m = {};
        _.each(that.all(), function(a) {
            var physician = a.getPhysician();
            if (physician) { m[physician.getCmsNpi()] = true; }
        });
        return m;
    };

    that.getTopRank = function(group) {
        if (group === 'other') {
            var others = that.allOther();
            return others.length ?
                _.max(others, function(a) { return a.getRank(); }).getRank() + 1 : 1;
        } else if (group === 'main') {
            var mains = that.allMain();
            return mains.length ?
                _.max(mains, function(a) { return a.getRank(); }).getRank() + 1 : 1;
        }
    };

    /**
     * Take an existing physician ID or a name/specialty/treatment note
     * and create a new patient provider, in the main group */
    that.createMainProvider = function(spec) {
        var mapped = (spec.data) ? $.extend({}, spec.data) : {};
        mapped['group'] = 'main';
        mapped['rank'] = that.getTopRank('main');
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('newPatientProvider', [spec.physicianId]),
            data: JSON.stringify(mapped),
            success: function(data) {
                var provider = that.create(data);
                if (spec.successCb) { spec.successCb(provider); }
            }
        });
    };

    /** NOTE: This method does not actually save the data to the server; it just
     * does the moving locally on the client. Need to call saveRankOrder to do
     * the save explicitly.
     */
    that.moveToMainGroup = function(id) {
        var provider = that.getById(id);
        if (provider.getGroup() === 'main') { return; }
        var allMain = that.allMain();
        var lenAllMain = allMain.length;
        _.each(allMain, function(elt, index) {
            elt.setSortSequence(index+1, lenAllMain);
        });
        provider.setGroup('main');
        provider.setSortSequence(0, lenAllMain);

        /* Clean ranks for other group */
        var allOther = that.allOther();
        var lenAllOther = allOther.length;
        _.each(that.allOther(), function(elt, index) {
            elt.setSortSequence(index, lenAllOther);
        });
    };

    /** NOTE: This method does not actually save the data to the server; it just
     * does the moving locally on the client. Need to call saveRankOrder to do
     * the save explicitly.
     */
    that.moveToOtherGroup = function(id) {
        var provider = that.getById(id);
        if (provider.getGroup() === 'other') { return; }
        var allOther = that.allOther();
        var lenAllOther = allOther.length;
        _.each(allOther, function(elt, index) {
            elt.setSortSequence(index+1, lenAllOther);
        });
        provider.setGroup('other');
        provider.setSortSequence(0, lenAllOther);

        /* Clean ranks for main group */
        var allMain = that.allMain();
        var lenAllMain = allMain.length;
        _.each(allMain, function(elt, index) {
            elt.setSortSequence(index, lenAllMain);
        });
    };

    that.saveRankOrder = function(opts) {
        opts = opts || {};
        var getIdFn = function(a) { return a.getId(); };
        var sortedMainProviderIds = that.allMain().map(getIdFn);
        var sortedOtherProviderIds = that.allOther().map(getIdFn);
        el8.appservice.notifier.notify('Updating ordering of providers...');
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('sortPatientProviders'),
            data: JSON.stringify([
                {group: 'main', patient_provider_ids: sortedMainProviderIds},
                {group: 'other', patient_provider_ids: sortedOtherProviderIds}
            ]),
            success: function() {
                if (opts.successCb) { opts.successCb(); }
                el8.appservice.notifier.notify('Provider List updated.');
                if (opts.noNotify !== true) {  // default trigger
                    el8.ptdata.ptProviders.trigger(EVENTS.MOVED);
                }
            }
        });
    };

    // We are going to implicitly default to excluding patient's practice PCP
    var super_all = that.all;
    that.all = function(includePrimary) {
        if (includePrimary) {
            return super_all.call(that);
        } else {
            return _.reject(super_all.call(that), function(a) {
                return a.getPhysician() && a.getPhysician().getAccessUserId() && el8.ptdata.currPatient &&
                    (el8.ptdata.currPatient.getPrimaryPhysicianUserId() === a.getPhysician().getAccessUserId());
            });
        }
    };


    that.allInGroup = function(group, sorted) {
        sorted = (sorted !== false); // default to sorting by rank, but allow override
        return that.sorted().filter(function(a) { return a.getGroup() === group; });
    };

    that.allMain = function(sorted) {
        return that.allInGroup('main', sorted);
    };

    that.allOther = function(sorted) {
        return that.allInGroup('other', sorted);
    };

    that.sortedByGroup = function(spec) {
        spec = spec || {};
        // get all the providers, by group
        var mainProviders = that.allMain(false);
        var otherProviders = that.allOther(false);

        // then sort by specialty - blank names go at the end
        var sortBySpecialtyFn = function(prov) {
            var specialties =  prov.getPhysician().getSpecialties();
            return specialties.length ? specialties[0].name.toLowerCase() : 'zz';
        };
        mainProviders = _.sortBy(mainProviders, sortBySpecialtyFn);
        otherProviders = _.sortBy(otherProviders, sortBySpecialtyFn);

        var soyMapFn = function(prov) {
            if (spec.indicatePracticeUsers) {
                var soyMap = prov.asSoyMap();
                soyMap.isPracticeUser = el8.data.practiceUsers.isMember(prov.getPhysician().getAccessUserId());
                return soyMap;
            } else {
                return prov.asSoyMap();
            }
        };
        mainProviders = mainProviders.map(soyMapFn);
        otherProviders = otherProviders.map(soyMapFn);

        return {
            mainProviders: mainProviders,
            otherProviders: otherProviders
        };
    };

    that.getByPhysicianId = function(physicianId) {
        return _.find(that.all(), function(ptProvider) { return ptProvider.getPhysicianId() === physicianId; });
    };

    that.getBySpecialtyCategoryId = function(categoryId, indicatePracticeUsers, addlFilters) {
        var filterFn = function(ptProvider) {
            var providerCategoryIds = _.pluck(ptProvider.getSpecialtyCategories(), 'id');
            var match = false;
            for (var i=0; i < providerCategoryIds.length; i++) {
                // if we're comparing 0 and null, we want to return True
                if (providerCategoryIds[i] === categoryId || !providerCategoryIds[i] && !categoryId) {
                    match = true;
                    break;
                }
            }
            return match;
        };
        return searchPtProviders(filterFn, indicatePracticeUsers, addlFilters);
    };

    that.getByName = function(name, indicatePracticeUsers, addlFilters) {
        var filterFn = function(ptProvider) {
            var fullName = ptProvider.getPhysician().getFullName().toLowerCase();
            return (fullName.indexOf(name.toLowerCase()) !== -1);
        };
        return searchPtProviders(filterFn, indicatePracticeUsers, addlFilters);
    };

    function searchPtProviders(filterFn, indicatePracticeUsers, addlFilters) {
        addlFilters = addlFilters || {};
        var sortFn = function(a, b) {
            // compare main/other, then (ln, fn) or (name)
            return el8.util.string.cmp(a.getGroup(), b.getGroup()) ||
                   el8.util.string.cmp(a.getPhysician().getReverseName(), b.getPhysician().getReverseName());
        };
        var r = _.filter(that.all(), function(ptProvider) {
            var match = filterFn(ptProvider);
            if (addlFilters.city) { match = match && ptProvider.getPhysician().getCity().toLowerCase() === addlFilters.city.toLowerCase(); }
            if (addlFilters.state) { match = match && ptProvider.getPhysician().getState().toUpperCase() === addlFilters.state.toUpperCase(); }
            return match;
        }).sort(sortFn);

        if (!indicatePracticeUsers) { return r; }
        return r.map(function(a) {
            return $.extend({}, a.asSoyMap(), {
                isPracticeUser: el8.data.practiceUsers.isMember(a.getPhysician().getAccessUserId())
            });
        });
    }

    return that;

})();
